import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Consumer } from '@app/resources/services';

enum NonConsumerActionTypes {
  UPSERT_NON_CONSUMER = 'Upsert Non Consumer',
  UPSERT_NON_CONSUMERS = 'Upsert Non Consumers',
  LOAD_NON_CONSUMERS = 'Load Non Consumers',
  LOAD_NON_CONSUMERS_SUCCESS = 'Load Non Consumers Success',
  LOAD_NON_CONSUMERS_ERROR = 'Load Non Consumers Error',
  SELECT_NON_CONSUMER = 'Non Consumer By Id',
}

export const NonConsumerActions = createActionGroup({
  source: 'Non Consumer',
  events: {
    [NonConsumerActionTypes.UPSERT_NON_CONSUMER]: props<{ payload: { consumer: Consumer } }>(),
    [NonConsumerActionTypes.UPSERT_NON_CONSUMERS]: props<{ payload: { consumers: Consumer[] } }>(),
    [NonConsumerActionTypes.LOAD_NON_CONSUMERS]: emptyProps(),
    [NonConsumerActionTypes.LOAD_NON_CONSUMERS_SUCCESS]: props<{
      payload: { consumers: Consumer[] };
    }>(),
    [NonConsumerActionTypes.LOAD_NON_CONSUMERS_ERROR]: props<{ payload: { error: string } }>(),
    [NonConsumerActionTypes.SELECT_NON_CONSUMER]: props<{ payload: { consumerId: number } }>(),
  },
});
